import functions from '../../../../../world/spa/libs/vuexFunctions';

export default {
    namespaced: true,
    state: {
        objs: []
    },
    getters: {
        ...functions.createDefaultGetters(['idContactsPlace']),
    },
    mutations: {
        ...functions.createDefaultMutations(['idContactsPlace'])
    },
    actions: {
        ...functions.createDefaultActionsWithStore(['idContactsPlace'])
    },
}